import { prefersReducedMotion } from './index';

// Track which buttons have been processed to prevent duplication
const processedButtons = new WeakSet();

export const initButtonsAnimation = () => {
  // Industries sections can contain buttons without the shared .module wrapper.
  const allButtons = document.querySelectorAll<HTMLElement>(
    '.module .btn, .industries-page .btn, .container > .btn--find-a-dealer'
  );

  if (prefersReducedMotion()) {
    return;
  }

  allButtons?.forEach(button => {
    // Skip if this button has already been processed
    if (processedButtons.has(button)) {
      return;
    }

    // Mark button as processed
    processedButtons.add(button);

    // Check if button already has the animation structure
    const existingWrapper = button.querySelector('.btn__text-wrapper');
    if (existingWrapper) {
      return;
    }

    const wrapper = document.createElement('span');
    wrapper.className = 'btn__text-wrapper';
    const text = document.createElement('span');
    text.className = 'btn__text';
    text.append(...Array.from(button.childNodes));
    const duplicate = text.cloneNode(true) as HTMLElement;
    duplicate.setAttribute('aria-hidden', 'true');
    duplicate.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
    wrapper.append(text, duplicate);
    button.append(wrapper);
  });

  allButtons?.forEach(button => {
    // Only process buttons that haven't been processed yet
    if (!processedButtons.has(button)) {
      return;
    }

    const texts = Array.from(button.querySelectorAll('.btn__text'));
    const height = texts
      .filter((_, index) => index === 0)
      .map(text => (text as HTMLElement).offsetHeight);

    if (height[0] !== undefined) {
      (button as HTMLElement).style.setProperty('--btn-height', `${height[0]}px`);
    }
  });

  allButtons?.forEach(button => {
    // Only set up resize observer for processed buttons that don't already have one
    if (
      !processedButtons.has(button) ||
      (button as HTMLElement).dataset.resizeObserverSetup === 'true'
    ) {
      return;
    }

    // Mark that resize observer has been set up
    (button as HTMLElement).setAttribute('data-resize-observer-setup', 'true');

    const resizeObserver = new ResizeObserver(() => {
      const texts = Array.from(button.querySelectorAll('.btn__text'));
      const height = texts
        .filter((_, index) => index === 0)
        .map(text => (text as HTMLElement).offsetHeight);
      if (height[0] !== undefined) {
        (button as HTMLElement).style.setProperty('--btn-height', `${height[0]}px`);
      }
    });

    resizeObserver.observe(button);
  });
};
